<template>
  <div id="page-campaign-statistics-data">
    <vs-alert v-if="!activeCampaign" active="true">
      {{ $t("Dashboard.NoActiveCampaign") }}
    </vs-alert>
    <vx-title-bar :route="$route" :isRTL="$vs.rtl" v-if="activeCampaign">
      <campaign-drop-down />
      <strategy-drop-down v-if="activeCampaign.hasStrategies" />
      <vc-date-picker
        color="purple"
        mode="range"
        :columns="2"
        :max-date="new Date()"
        v-model="localRange"
      />
      <vs-dropdown
        vs-trigger-click
        v-if="$acl.check('editor')"
        class="ml-auto md:block hidden cursor-pointer"
      >
        <vs-button radius icon="icon-more-vertical" icon-pack="feather" />
        <vs-dropdown-menu>
          <vs-dropdown-item>
            <div @click="gotoDetails" class="flex items-center">
              <feather-icon
                icon="ArrowRightCircleIcon"
                class="inline-block mr-2"
                svgClasses="w-4 h-4"
              />
              <span>{{ this.$t("Campaign.View") }}</span>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vx-title-bar>
    <div class="vx-row" v-if="activeCampaign">
      <div class="vx-col w-full mb-base">
        <statistics-grid />
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import StatisticsGrid from "@/views/components/StatisticsGrid"
import CampaignDropDown from "@/views/components/CampaignDropDown.vue"
import StrategyDropDown from "@/views/components/StrategyDropDown.vue"

export default {
  data () {
    return {
      localRange: {},
      sessionsData: {},
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  components: {
    StatisticsGrid,
    CampaignDropDown,
    StrategyDropDown
  },
  created () {
    this.localRange = this.$store.state.statistics.range
  },
  methods: {
    gotoDetails () {
      this.$router.push(`/campaign/view/${this.activeCampaign.id}`)
    }
  },
  computed: {
    ...mapGetters([
      "activeOrganisation",
      "activeCampaign",
      "activeStrategy"
    ]),
  },
  watch: {
    localRange: function (val) {
      this.$store.dispatch("statistics/setRange", val)
    }
  },
}
</script>
